import { createContext, useContext } from 'react';

export const FeatureFlagsContext = createContext();

export const useFeatureFlags = () => useContext(FeatureFlagsContext) || {};
